import { partners, Partner } from '@/data/partners';

interface PartnerLogosSectionProps {
  title?: string;
  description?: string;
  showDescription?: boolean;
  partnerFilter?: (partner: Partner) => boolean;
  className?: string;
}

const PartnerLogosSection = ({ 
  title = "Trusted Partners",
  description = "Integrated with services you already know and trust",
  showDescription = false,
  partnerFilter,
  className = ""
}: PartnerLogosSectionProps) => {
  const displayPartners = partnerFilter ? partners.filter(partnerFilter) : partners;

  return (
    <div className={`py-16 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
            {title}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {description}
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-8 items-center justify-items-center">
          {displayPartners.map((partner) => (
            <div 
              key={partner.name}
              className="group flex flex-col items-center gap-3 p-4 rounded-lg hover:bg-muted/50 transition-colors"
              title={showDescription ? partner.description : partner.name}
            >
              <div className="w-16 h-16 flex items-center justify-center">
                <img 
                  src={partner.logo} 
                  alt={partner.logoAlt}
                  className="max-w-full max-h-full object-contain opacity-70 group-hover:opacity-100 transition-opacity filter grayscale group-hover:grayscale-0"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              {showDescription && (
                <div className="text-center">
                  <p className="text-sm font-medium text-foreground mb-1">{partner.name}</p>
                  <p className="text-xs text-muted-foreground">{partner.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <p className="text-sm text-muted-foreground">
            And many more partners to enhance your daily life
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerLogosSection;